import Vue from "vue";
import App from "./App.vue";
// import './registerServiceWorker'
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "./filters";
import "./plugins/toastification";
import "./plugins/persianDatePicker";
import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload);

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
Vue.use(VueViewer);

// or with options
// const loadimage = require("./assets/loading.gif");
// const errorimage = require("./assets/error.gif");

Vue.use(VueLazyload, {
  preLoad: 1.3,
  // error: errorimage,
  // loading: loadimage,
  attempt: 1,
  lazyComponent: true
});
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
